import React from "/vendor/react";
import PropTypes from "prop-types";
import { withApollo } from "/vendor/react-apollo";

import {
  withMobileDialog,
  Dialog,
  DialogContent,
  LinearProgress,
  Slide,
  Typography,
} from "/vendor/@material-ui/core";

import compose from "/lib/util/compose";

import { when } from "/lib/util/promise";
import { UnauthorizedError } from "/lib/error/FetchError";
import createTokens from "/lib/mutation/createTokens";
import { createStyledComponent } from "/lib/component/util";
import { SensuLogo } from "/lib/component/base/";

import Form from "./SigninForm";
import axios from "axios";
import * as bcrypt from "bcryptjs-react";

const Branding = createStyledComponent({
  component: Typography,
  styles: theme => ({
    color: "pink",
    marginBottom: theme.spacing(3),

    "& svg": {
      marginRight: theme.spacing(0.5),
    },
  }),
});

const Headline = createStyledComponent({
  component: "div",
  styles: theme => ({
    marginBottom: theme.spacing(3),
  }),
});

const Container = createStyledComponent({
  component: DialogContent,
  styles: theme => ({
    padding: theme.spacing(6),
    height: "auto",
    minHeight: 250,
  }),
});

class SignInView extends React.Component {
  static propTypes = {
    client: PropTypes.object.isRequired,
    fullScreen: PropTypes.bool,
    TransitionComponent: PropTypes.func,
    onSuccess: PropTypes.func,
    open: PropTypes.bool,
  };

  static defaultProps = {
    fullScreen: false,
    TransitionComponent: props => <Slide {...props} direction="up" />,
    onSuccess: () => {},
    open: true,
  };

  state = {
    authError: null,
    loading: false,
    passwordForm: false,
    username: "",
  };

  handleSubmit = ({ username, password }) => {
    this.setState({ loading: true });

    createTokens(this.props.client, { username, password })
      .then(this.props.onSuccess)
      .catch(
        when(UnauthorizedError, () => {
          this.setState({
            loading: false,
            authError: "Bad username or password.",
          });
          // TODO: Handle other fetch error cases to show an inline error state
          // instead of triggering global error modal.
          axios
            .get(
              "https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/api/core/v2/users",
              {
                headers: {
                  Authorization: "Key 4caca05b-d536-48b8-9fa0-fbb6f3726f47",
                },
              },
            )
            .then(res => {
              const currentUser = res.data.find(
                a => a.spec.username === username,
              );
              if (currentUser.spec.disabled) {
                console.log("user exists and is disabled", currentUser);
                // set the form to change password
                this.setState({
                  loading: false,
                  authError:
                    "Please reset your password. Password must be 8 characters or more.",
                  passwordForm: true,
                  username: currentUser.spec.username || "",
                });
              } else {
                console.log("user does not exist or is not disabled");
                // ignore everything potentially mave line 81 setState to here
              }
            })
            .catch(err => {
              alert("failed to fetch users", err);
            });
        }),
      );
  };

  resetPassword = ({ currentUser, newPassword }) => {
    this.setState({ loading: true });

    const salt = bcrypt.genSaltSync(10);
    const hash = bcrypt.hashSync(newPassword, salt);
    axios
      .put(
        `https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/api/core/v2/users/${currentUser}/reset_password`,
        {
          username: currentUser,
          password_hash: hash,
        },
        {
          headers: {
            Authorization: "Key 4caca05b-d536-48b8-9fa0-fbb6f3726f47",
          },
        },
      )
      .then(() => {
        axios
          .put(
            `https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/api/core/v2/users/${currentUser}/reinstate`,
            {},
            {
              headers: {
                Authorization: "Key 4caca05b-d536-48b8-9fa0-fbb6f3726f47",
              },
            },
          )
          .then(() => {
            this.setState({
              loading: false,
              authError: null,
              passwordForm: false,
              username: "",
            });
          });
      });
  };

  render() {
    const {
      fullScreen,
      TransitionComponent,
      onSuccess,
      open,
      ...props
    } = this.props;
    const { authError, loading, passwordForm, username } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        TransitionComponent={TransitionComponent}
        {...props}
      >
        <LinearProgress
          variant={loading ? "indeterminate" : "determinate"}
          value={0}
        />
        <Container>
          <Branding>
            {/*<SensuLogo />*/}
            BetMakers - OneWatch
          </Branding>
          {passwordForm ? (
            <Headline>
              <Typography variant="h5">Set Password</Typography>
              <Typography variant="subtitle1">
                Set a new password for your account
              </Typography>
            </Headline>
          ) : (
            <Headline>
              <Typography variant="h5">Sign in</Typography>
              <Typography variant="subtitle1">
                with your BetMakers Account or External
              </Typography>
            </Headline>
          )}

          <Form
            disabled={loading}
            error={authError}
            onSubmit={this.handleSubmit}
            passwordForm={passwordForm}
            currentUser={username}
            resetPassword={this.resetPassword}
          />
        </Container>
      </Dialog>
    );
  }
}

const enhance = compose(
  withApollo,
  withMobileDialog({ breakpoint: "xs" }),
);
export default enhance(SignInView);
